import React from 'react';
import { useAuth } from '../hooks/useAuth';
import NovagobDashboard from './dashboards/NovagobDashboard';
import JuryDashboard from './dashboards/JuryDashboard';
import PublicDashboard from './dashboards/PublicDashboard';

const Dashboard: React.FC = () => {
  const { isNovagobTeam, isJury, loading } = useAuth();

  if (loading) {
    return (
      <div className="loading">
        <div className="spinner"></div>
      </div>
    );
  }

  // Prioridad: Novagob Team > Jury > Public
  if (isNovagobTeam) {
    return <NovagobDashboard />;
  }

  if (isJury) {
    return <JuryDashboard />;
  }

  return <PublicDashboard />;
};

export default Dashboard;
